/**
 * Expands ribbon description templates using qtyRequirement from DB.
 *
 * Placeholders (case-insensitive):
 * - {{qtyTimes}} — empty when qty <= 1, otherwise " 10 times" (leading space included)
 * - {{qty}} — requirement number when qty > 1, otherwise empty
 *
 * Example (qty = 10):
 *   "Awarded to a member who participated{{qtyTimes}} to a Wake..."
 *   → "Awarded to a member who participated 10 times to a Wake..."
 */
export function formatRibbonDescription(description, qtyRequirement) {
  const text = String(description ?? "").trim();
  if (!text) return "";

  const raw = Number(qtyRequirement);
  const qty = Number.isInteger(raw) && raw > 0 ? raw : 1;
  const qtyTimes = qty > 1 ? ` ${qty} times` : "";
  const qtyStr = qty > 1 ? String(qty) : "";

  return text
    .replace(/\{\{qtyTimes\}\}/gi, qtyTimes)
    .replace(/\{\{qty\}\}/gi, qtyStr);
}
